/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function FlowerDownloadIcon(props) {
  return (
    <svg
      {...props}
      width="104"
      height="104"
      viewBox="0 0 104 104"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Fondo de flor/asterisco */}
      <g clipPath="url(#clip0_flower)">
        <path
          d="M11.5727 11.5718C0.843663 22.3009 0.843736 39.6959 11.5727 50.4249C12.4426 51.2948 12.4426 52.7052 11.5727 53.5751C0.843736 64.3041 0.843663 81.6991 11.5727 92.4282C22.3018 103.157 39.6969 103.157 50.4259 92.4283C51.2958 91.5584 52.7061 91.5583 53.5759 92.428C64.3049 103.157 81.7 103.157 92.4291 92.4282C103.158 81.6991 103.158 64.3039 92.4291 53.5748C91.5593 52.7051 91.5593 51.2949 92.4291 50.4252C103.158 39.6961 103.158 22.3009 92.4291 11.5718C81.7 0.842779 64.3049 0.842925 53.5759 11.572C52.7061 12.4417 51.2958 12.4416 50.4259 11.5717C39.6969 0.842706 22.3018 0.842779 11.5727 11.5718Z"
          fill="white"
        />
        <path
          d="M11.5727 11.5718C0.843663 22.3009 0.843736 39.6959 11.5727 50.4249C12.4426 51.2948 12.4426 52.7052 11.5727 53.5751C0.843736 64.3041 0.843663 81.6991 11.5727 92.4282C22.3018 103.157 39.6969 103.157 50.4259 92.4283C51.2958 91.5584 52.7061 91.5583 53.5759 92.428C64.3049 103.157 81.7 103.157 92.4291 92.4282C103.158 81.6991 103.158 64.3039 92.4291 53.5748C91.5593 52.7051 91.5593 51.2949 92.4291 50.4252C103.158 39.6961 103.158 22.3009 92.4291 11.5718C81.7 0.842779 64.3049 0.842925 53.5759 11.572C52.7061 12.4417 51.2958 12.4416 50.4259 11.5717C39.6969 0.842706 22.3018 0.842779 11.5727 11.5718Z"
          fill="url(#paint0_radial_flower)"
          fillOpacity="0.3"
        />
      </g>

      {/* Icono de descarga centrado (escalado y posicionado) */}
      <g transform="translate(40, 39.75) scale(1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.6667 0.75C7.97635 0.75 7.4167 1.30964 7.4167 2V11.5833H2.00004C1.49446 11.5833 1.03866 11.8879 0.845187 12.355C0.651711 12.8221 0.758655 13.3597 1.11615 13.7172L11.1162 23.7172C11.6043 24.2054 12.3958 24.2054 12.8839 23.7172L22.8839 13.7172C23.2414 13.3597 23.3484 12.8221 23.1549 12.355C22.9614 11.8879 22.5056 11.5833 22 11.5833H16.5834V2C16.5834 1.30964 16.0237 0.75 15.3334 0.75H8.6667Z"
          fill="#141A1F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.6667 0.75C7.97635 0.75 7.4167 1.30964 7.4167 2V11.5833H2.00004C1.49446 11.5833 1.03866 11.8879 0.845187 12.355C0.651711 12.8221 0.758655 13.3597 1.11615 13.7172L11.1162 23.7172C11.6043 24.2054 12.3958 24.2054 12.8839 23.7172L22.8839 13.7172C23.2414 13.3597 23.3484 12.8221 23.1549 12.355C22.9614 11.8879 22.5056 11.5833 22 11.5833H16.5834V2C16.5834 1.30964 16.0237 0.75 15.3334 0.75H8.6667Z"
          fill="url(#paint1_radial_download)"
          fillOpacity="0.5"
        />
      </g>

      {/* Definiciones de los gradientes y clipPath */}
      <defs>
        <radialGradient
          id="paint0_radial_flower"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(50.9902 22.6896) rotate(113.491) scale(155.939 74.7034)"
        >
          <stop stopColor="#C9B719" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>

        <radialGradient
          id="paint1_radial_download"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1.88637 4.39583) rotate(43.9999) scale(48.0753 23.0752)"
        >
          <stop stopColor="#C91945" />
          <stop offset="1" stopColor="#E4B6FF" />
        </radialGradient>

        <clipPath id="clip0_flower">
          <rect width="104" height="104" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

FlowerDownloadIcon.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default FlowerDownloadIcon
